<template>
  <section class="">
    <div class="allDataPre">
      <p class="title">数据总览</p>
      <van-row>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv1 }}</p>
          <p class="num">一级-区域经销商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv2 }}</p>
          <p class="num">二级-城区经销商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv3 }}</p>
          <p class="num">三级-城市经销商</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv4 }}</p>
          <p class="num">四级-甲经销商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv5 }}</p>
          <p class="num">五级-乙经销商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv6 }}</p>
          <p class="num">六级-丙经销商</p>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv7 }}</p>
          <p class="num">渠道经销商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lv9 }}</p>
          <p class="num">KA运营商</p>
        </van-col>
        <van-col span="8">
          <p class="itemTitle">{{ addDataPre.lvall }}</p>
          <p class="num">合计</p>
        </van-col>
      </van-row>
    </div>
    <Map
      v-if="showMap"
      @mapCodeChange="mapCodeChange"
      style="height: calc(100vw + 95px); width: 100vw; background: #ffffff"
    ></Map>
    <div class="allDataPre">
      <p class="title">客户活跃度</p>
      <div class="activityList">
        <div class="activityItem" @click="intoDetail('in_1month')">
          <p>
            <span class="cc" style="background-color: #7585a2"></span>
            <span class="t">一个月内有交易</span>
          </p>
          <van-row>
            <van-col span="19">
              <p class="progressP">
                <van-progress
                  pivot-text
                  stroke-width="15"
                  color="#7585A2"
                  :percentage="transaction.month1P"
                />
              </p>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="4">
              <p class="progressNum">{{ transaction.month1 }}</p>
            </van-col>
          </van-row>
        </div>
        <div class="activityItem" @click="intoDetail('in_3month')">
          <p>
            <span class="cc" style="background-color: #03c5a9"></span>
            <span class="t">一至三个月内有交易</span>
          </p>
          <van-row>
            <van-col span="19">
              <p class="progressP">
                <van-progress
                  pivot-text
                  stroke-width="15"
                  color="#03C5A9"
                  :percentage="transaction.month3P"
                />
              </p>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="4">
              <p class="progressNum">{{ transaction.month3 }}</p>
            </van-col>
          </van-row>
        </div>
        <div class="activityItem" @click="intoDetail('in_6month')">
          <p>
            <span class="cc" style="background-color: #4399fc"></span>
            <span class="t">三至六个月内有交易</span>
          </p>
          <van-row>
            <van-col span="19">
              <p class="progressP">
                <van-progress
                  pivot-text
                  stroke-width="15"
                  color="#4399FC"
                  :percentage="transaction.month6P"
                />
              </p>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="4">
              <p class="progressNum">{{ transaction.month6 }}</p>
            </van-col>
          </van-row>
        </div>
        <div class="activityItem" @click="intoDetail('in_12month')">
          <p>
            <span class="cc" style="background-color: #fcd04c"></span>
            <span class="t">半年至一年内有交易</span>
          </p>
          <van-row>
            <van-col span="19">
              <p class="progressP">
                <van-progress
                  pivot-text
                  stroke-width="15"
                  color="#FCD04C"
                  :percentage="transaction.month12P"
                />
              </p>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="4">
              <p class="progressNum">{{ transaction.month12 }}</p>
            </van-col>
          </van-row>
        </div>
        <div class="activityItem" @click="intoDetail('in_other')">
          <p>
            <span class="cc" style="background-color: #fc6b6b"></span>
            <span class="t">一年前有交易</span>
          </p>
          <van-row>
            <van-col span="19">
              <p class="progressP">
                <van-progress
                  pivot-text
                  stroke-width="15"
                  color="#FC6B6B"
                  :percentage="transaction.otherP"
                />
              </p>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="4">
              <p class="progressNum">{{ transaction.other }}</p>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Map from "../../components/jlbMap/map.vue";
// import initJSSDK from "./assets/js/initJSSDK.js"

export default {
  name: "test",
  data() {
    return {
      mapData: [],
      showMap: true,
      addDataPre: {
        lv1: 0,
        lv2: 0,
        lv3: 0,
        lv4: 0,
        lv5: 0,
        lv6: 0,
        lv7: 0,
        lv8: 0,
        lv9: 0,
        lvall: 0
      },
      transaction: {
        total: 0,
        never: 0,
        month3: 0,
        month6: 0,
        month12: 0,
        other: 0,
        month1: 0,
        neverP: 0,
        month3P: 0,
        month6P: 0,
        month12P: 0,
        otherP: 0,
        month1P: 0
      },
      code: "000000"
    };
  },
  components: {
    Map
  },
  mounted() {},
  methods: {
    mapCodeChange(code) {
      this.code = code;
      this.getActivityListData();
    },
    intoDetail(type) {
      this.$router.push({
        path: "/mapDetailList",
        query: {
          code: this.code,
          type: type
        }
      });
    },
    getActivityListData() {
      this.$common
        .http({
          mt: "post",
          url: "/wxapi/order/list_active",
          data: {
            code: this.code
          }
        })
        .then(res => {
          let neverP =
            (res.data.data.never / res.data.data.total).toFixed(4) * 100;
          let month3P =
            (res.data.data.in_3month / res.data.data.total).toFixed(4) * 100;
          let month6P =
            (res.data.data.in_6month / res.data.data.total).toFixed(4) * 100;
          let month12P =
            (res.data.data.in_12month / res.data.data.total).toFixed(4) * 100;
          let otherP =
            (res.data.data.in_other / res.data.data.total).toFixed(4) * 100;
          let month1P =
            (res.data.data.in_1month / res.data.data.total).toFixed(4) * 100;
          this.transaction = {
            total: res.data.data.total,
            never: res.data.data.never,
            month3: res.data.data.in_3month,
            month6: res.data.data.in_6month,
            month12: res.data.data.in_12month,
            month1: res.data.data.in_1month,
            other: res.data.data.in_other,
            neverP: neverP >= 100 ? 100 : neverP,
            month3P: month3P >= 100 ? 100 : month3P,
            month6P: month6P >= 100 ? 100 : month6P,
            month12P: month12P >= 100 ? 100 : month12P,
            otherP: otherP >= 100 ? 100 : otherP,
            month1P: month1P >= 100 ? 100 : month1P
          };
          // this.addDataPre = {
          //   customers: res.data.data.total,
          //   acCustomers: res.data.data.in_3month,
          //   enCustomers: res.data.data.never,
          // };
          let lvall =
            Number(res.data.data.type_cnt["22078764"]) +
            Number(res.data.data.type_cnt["22077162"]) +
            Number(res.data.data.type_cnt["22080366"]) +
            Number(res.data.data.type_cnt["22081968"]) +
            Number(res.data.data.type_cnt["22083570"]) +
            Number(res.data.data.type_cnt["22085172"]) +
            Number(res.data.data.type_cnt["22089978"]) +
            Number(res.data.data.type_cnt["00000000"]);
          this.addDataPre = {
            lv1: res.data.data.type_cnt["22078764"] || 0,
            lv2: res.data.data.type_cnt["22077162"] || 0,
            lv3: res.data.data.type_cnt["22080366"] || 0,
            lv4: res.data.data.type_cnt["22081968"] || 0,
            lv5: res.data.data.type_cnt["22083570"] || 0,
            lv6: res.data.data.type_cnt["22085172"] || 0,
            lv7: res.data.data.type_cnt["22089978"] || 0,
            lv8: res.data.data.type_cnt["20316564"] || 0,
            lv9: res.data.data.type_cnt["00000000"] || 0,
            lvall: lvall || 0
          };
        });
    },
    getMapData(code) {
      return new Promise(resolve => {
        this.$common
          .req("/wxapi/distributor/load_map", {
            code: code
          })
          .then(res => {
            resolve(res);
          });
      });
    }
  },
  async created() {
    // this.getActivityListData();
    // initJSSDK();
  }
};
</script>
<style lang="less" scope>
.allDataPre {
  background: #ffffff;
  padding: 10px 15px;
  margin: 10px 0;
  .title {
    font-size: 16px;
    color: #4a4a4a;
    padding-bottom: 8px;
  }
  .itemTitle {
    text-align: center;
    font-size: 21px;
    color: rgba(0, 0, 0, 0.8);
  }
  .num {
    font-size: 11px;
    text-align: center;
    color: #666666;
  }
  .activityList {
    .activityItem {
      .cc {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 5px;
      }
      .t {
        font-size: 14px;
        color: #333333;
      }
      .progressP {
        padding: 10px 0;
      }
      .progressNum {
        font-size: 14px;
        color: #666666;
        line-height: 35px;
      }
    }
  }
}
</style>
<style lang="less">
// 隐藏地图icon
.amap-logo {
  display: none;
  opacity: 0 !important;
}
.amap-copyright {
  opacity: 0;
}
</style>
